function TolstoyStories({ productId }: { productId: string }) {
	return (
		<div
			dangerouslySetInnerHTML={{
				__html: `
            <tolstoy-stories class="tolstoy-stories"
              data-publish-id="49lnwyqh30kfm"
              data-product-id=${productId}
            </tolstoy-stories>
        `,
			}}
		/>
	)
}

export default TolstoyStories
